import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=2abd7f76"
import script from "./paper.vue?vue&type=script&lang=js"
export * from "./paper.vue?vue&type=script&lang=js"
import style0 from "./paper.vue?vue&type=style&index=0&id=2abd7f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports